<template>
    <div class="ut-flex">
    
        <button
          v-for="item in buttonList"
          :key="item.value"
          class="dt-button dt-button v5 s8"
          :class="{ 'ut-text-error': item.text=='Delete' }"
          @click="onClick(item.value)"
          style="margin-top: 8px; margin-left: 0px;width:120px;min-width:120px"
          :style="{
                    borderColor:item.text=='Delete'?'var(--c-error)':'var(--bc-accent5)',
                    color:item.text=='Delete'?'var(--c-error)':'var(--bc-accent5)'
                  }"
        >
           {{item.text}}
        </button>
    </div>
</template>
<script>

export default {
  props: {
    buttonList:{
      type:Array
    }
  },
  components: {

  },
  data: function() {
    return {
    };
  },
  computed: {
  },
  methods: {
     //...mapActionObject(storeNS, distributionStatementsActions),
     onClick:function(menu){
        this.$emit('menuClick',menu)
     }
  }
};
</script>
